import React from "react";
import InternshipAppdev from "../Internships/components/InternshipAppdev";

const AppDevelopment = () => {
  return (
    <>
     
      <div className="container my-5 enroll">
        <div className="row py-5  ">
          <div className=" col-md-6 ">
            <div className="mt-5 px-5 me-3">
              <div className="">
                <h3 className="course-heading  ">App Development</h3>
                <p className="text-justify ">
                  Dive into the world of app development with this comprehensive course. From understanding the basics of Android development to mastering advanced architectural patterns, this program equips you with the skills needed to build robust, user-friendly apps. Whether you're creating a simple to-do list app or an intricate e-commerce platform, you'll gain hands-on experience with real-world tools and techniques.
                </p>
              </div>
            </div>
          </div>
          <div className=" col-md-6  ">
            <div className="mt-2">
              <img
                className="img-fluid mx-auto d-flex"
                width="100%"
                src={require("../../assets/images/Hire-our-Wordpress-Developer.png")}
              />{" "}
            </div>
          </div>
        </div>
      </div>
      <InternshipAppdev />
    </>
  );
};

export default AppDevelopment;
